import { useLocation, useParams } from 'react-router-dom';
import './CadastroReaders.css';
import ReadersService from '../../../services/ReadersService';
import { useEffect, useState } from 'react';
import CadastroContainer from '../../../components/CadastroContainer/CadastroContainer';
import { ReaderModelFromSlugs } from '../../../constants/readers-model';
import { FormReaders } from '../FormReaders/FormReaders';

export function CadastroReaders({ ...props }) {
   const { readerModel, readerId } = useParams();
   const { state } = useLocation();
   const [reader, setReader] = useState(state);
   const [type, setType] = useState("");

   async function loadReader(id) {
      const response = await ReadersService.getReader(id);
      if (response.data) {
         setReader(response.data);
      }
   }

   useEffect(() => {
      setType(readerId || state ? "edicao" : "cadastro");

      if (reader) {
         setReader(state);
         return;
      }

      if (readerId) {
         loadReader(readerId);
      }
   }, [state, readerId]);

   const model = readerModel ? ReaderModelFromSlugs[readerModel] : reader?.model;

   return (
      <CadastroContainer>
         <FormReaders model={model} reader={reader} type={type} />
      </CadastroContainer>
   );
}